import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-0.5 material-icons-outlined"
}
const _hoisted_2 = {
  key: 1,
  class: "mr-0.5 text-danger-dark -mt-0.5"
}
const _hoisted_3 = {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M9 8H11V14H9V8M13 1H7V3H13V1M17.03 7.39C18.26 8.93 19 10.88 19 13C19 17.97 15 22 10 22C5.03 22 1 17.97 1 13S5.03 4 10 4C12.12 4 14.07 4.74 15.62 6L17.04 4.56C17.55 5 18 5.46 18.45 5.97L17.03 7.39M17 13C17 9.13 13.87 6 10 6S3 9.13 3 13 6.13 20 10 20 17 16.87 17 13M21 7V13H23V7H21M21 17H23V15H21V17Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center w-max text-muted", {
			shake:
				(_ctx.littleTimeRemaining && !_ctx.hasShakenLittleTime) ||
				(_ctx.lessThanHalfTimeRemaining && !_ctx.hasShakenHalfTime),
			'opacity-0': !_ctx.isInitialTimeValid,
		}]),
    onAnimationend: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShakeEnd()))
  }, [
    (!_ctx.littleTimeRemaining)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "timer"))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
        ])),
    _createElementVNode("p", {
      class: _normalizeClass(["ml-1", {
				'text-danger-dark': _ctx.littleTimeRemaining,
			}])
    }, [
      (_ctx.initialSeconds >= 3600)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.formattedTime.hours) + ":", 1))
        : _createCommentVNode("", true),
      _createTextVNode(_toDisplayString(_ctx.formattedTime.minutes) + ":" + _toDisplayString(_ctx.formattedTime.seconds), 1)
    ], 2)
  ], 34))
}